import type { MCart } from "@/Models/MCheckout/MCcart";
import type { Price } from "@/Type/Price";
import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "CheckoutDataCache";

export const useBuyCart = () => {
  //estado inicial del arreglo.
  const [addCheckoutSKU, setAddCheckoutSKU] = useState<MCart[]>(() => {
    //estado inicial desde localStorage
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  });

  //agregar al carrito
  const AddCartGo = useCallback(
    (
      IdSKU: string,
      TitleProduct: string,
      SoldByProduct: string,
      PriceProduct: Price,
      ImageProduct: string,
      LimitQuantity: number, //LimitQuantity
      Quantity = 1,
      Country = "",
      City = "",
      ZipCode = 0,
      Cupon = ""
    ) => {
      setAddCheckoutSKU((prev) => {
        const index = prev.findIndex((i) => i.IdSKU === IdSKU);
        //Si existe datos ya existente al que ya esta en el modelo de dato
        if (index !== -1) {
          const updated = prev.map((m) => {
            if (m.IdSKU === IdSKU) {
              const newQunatity = Math.max(0, (m.Quantity ?? 0) + Quantity);
              const newTotal = (m.PriceProduct ?? 0) * newQunatity;
              return {
                ...m,
                Quantity: newQunatity,
                PriceTotal: newTotal,
              } as MCart;
            }
            return m;
          });
          return updated.filter((item) => (item.Quantity ?? 0) > 0);
        }

        const PriceTota = (PriceProduct ?? 0) * Quantity;

        //si no existe datos.
        const updated = [
          ...prev,
          {
            IdSKU,
            TitleProduct,
            SoldByProduct,
            PriceProduct,
            ImageProduct,
            LimitQuantity,
            PriceTota,
            Quantity: 1,
            Country,
            City,
            ZipCode,
            Cupon,
          },
        ];
        return updated;
      });
    },
    []
  );

  //Si existe datos ya existente al que ya esta en el modelo de dato
  const UpdateCountCart = useCallback((IdSKU: string, quantity: Price) => {
    const data = addCheckoutSKU.find((w) => w.IdSKU === IdSKU);
    if (data) {
      setAddCheckoutSKU((prev) => {
        const updated = prev.map((item) => {
          if (item.IdSKU === IdSKU) {
            const newQuantity = Math.max(0, quantity);
            const newTotal = (item.PriceProduct ?? 0) * newQuantity;

            return {
              ...item,
              Quantity: newQuantity,
              PriceTotal: newTotal,
            };
          }
          return item;
        });

        return updated.filter((item) => Number(item.Quantity) > 0);
      });
    }
  }, []);

  //eliminamos del carrito
  const DeleteCart = useCallback(
    (sku: string) =>
      setAddCheckoutSKU((prev) => prev.filter((w) => w.IdSKU !== sku)),
    []
  );

  const SendBuyCartV2 = useCallback(
    (
      idSkus: string[],
      Country: string,
      City: string,
      ZipCode: number,
      Cupon: string
    ) => {
      const data = addCheckoutSKU.map((w) => idSkus.includes(w.IdSKU));
      if (data) {
        setAddCheckoutSKU((prev) => {
          const updated = prev.map((item) => {
            let id = idSkus.find((x) => x === item.IdSKU);
            if (idSkus.includes(item.IdSKU)) {
              return {
                ...item,
                Country: Country,
                City: City,
                ZipCode: ZipCode,
                Cupon: Cupon,
              };
            }
            return item;
          });
          localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
          return updated;
        });
      }
    },
    [addCheckoutSKU, setAddCheckoutSKU]
  );

  //obtenemos la cantidad de pedido del carrito segun su articulo
  const ViewCart = useCallback(
    (sku: string): Number => {
      const data = addCheckoutSKU.find((w) => w.IdSKU === sku);
      return data ? Number(data?.Quantity ?? 0) : 0;
    },
    [addCheckoutSKU]
  );

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(addCheckoutSKU));
  }, [addCheckoutSKU]);

  return {
    addCheckoutSKU,
    AddCartGo,
    DeleteCart,
    ViewCart,
    UpdateCountCart,
    //SendBuyCart,
    SendBuyCartV2,
  };
};
